import {postRequest, formDataRequest} from '../libs/AxiosService.util';

export async function serviceHqManpowerList(params) {
    return await postRequest('manpower', params);
}
export async function serviceDownloadManpowerCount(params) {
    return await postRequest('employees/export/ManPowerCount', params);
}